var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import * as s from './InvoiceInfo.scss';
import * as get from 'lodash.get';
import { Text, Heading } from 'wix-style-react';
import { dateFormat, localDate } from '../../../core';
import { translate } from 'react-i18next';
import { InvoiceStatus, } from '@wix/ambassador-wix-quotes-web/types';
import * as moment from 'moment';
import { WithInvoiceInfoLoader, } from '../../loaders/loaders-builder';
var diffInDaysFloored = function (_a) {
    var dateA = _a.dateA, dateB = _a.dateB;
    return Math.floor(moment.duration(moment(dateA).diff(dateB)).as('days'));
};
export var ORDER_REFERENCE_CUSTOM_FIELD_KEY = 'invoices.document.order-number';
var InvoiceInfo = function (_a) {
    var t = _a.t, invoice = _a.invoice, isRecurring = _a.isRecurring, status = _a.status, documentCustomFields = _a.documentCustomFields, customInvoiceNumberLabel = _a.customInvoiceNumberLabel, customFields = _a.customFields;
    var date = localDate(dateFormat({ locale: invoice.locale && invoice.locale.language }));
    var shouldModifyDatesForRecurringSpecialCase = isRecurring && status === InvoiceStatus.Draft;
    var referenceText = get(invoice.metaData, 'sourceProperties.referenceText');
    var dueDateOffset = shouldModifyDatesForRecurringSpecialCase
        ? diffInDaysFloored({
            dateA: get(invoice.dates, 'dueDate'),
            dateB: get(invoice.dates, 'issueDate'),
        })
        : null;
    var issueDate = shouldModifyDatesForRecurringSpecialCase
        ? moment().startOf('day').utc().toDate()
        : get(invoice.dates, 'issueDate');
    var dueDate = shouldModifyDatesForRecurringSpecialCase
        ? moment().add(dueDateOffset, 'days').startOf('day').utc().toDate()
        : get(invoice.dates, 'dueDate');
    var InfoLine = function (_a) {
        var children = _a.children, props = __rest(_a, ["children"]);
        return (React.createElement(Text, __assign({ size: 'tiny', weight: 'thin', secondary: true }, props), children));
    };
    var OrderReference = function () {
        var orderReferenceCustomField = customFields === null || customFields === void 0 ? void 0 : customFields.find(function (_a) {
            var originCustomFieldKey = _a.originCustomFieldKey;
            return originCustomFieldKey === ORDER_REFERENCE_CUSTOM_FIELD_KEY;
        });
        return orderReferenceCustomField ? (React.createElement(InfoLine, { dataHook: "order-reference" }, t('invoice-view:invoice-view.order-number.label', {
            orderNumber: orderReferenceCustomField.value.value,
        }))) : null;
    };
    var getCustomFields = function () {
        return documentCustomFields
            .filter(function (_a) {
            var value = _a.value, displayName = _a.displayName;
            return !!value && !!displayName;
        })
            .map(function (_a, index) {
            var displayName = _a.displayName, value = _a.value;
            return (React.createElement("div", { key: index },
                React.createElement(InfoLine, { dataHook: displayName + "-" + index + "-custom-field" }, t('invoice-view:price-quote.view.custom-field', {
                    displayName: displayName,
                    value: value,
                }))));
        });
    };
    var invoiceNumber = customInvoiceNumberLabel
        ? t('invoice-view:invoice_view.custom-invoice-number-label', {
            customInvoiceNumberLabel: customInvoiceNumberLabel,
            number: invoice.number,
        })
        : t('invoice-view:invoice_view.invoice_number', { number: invoice.number });
    var dueDateLine = function () {
        return !!dueDate && (React.createElement(InfoLine, { className: s.date, dataHook: "due-date" }, t('invoice-view:quote.form.due_date') + ": " + date(new Date(dueDate))));
    };
    var issueDateLine = function () {
        return !!issueDate && (React.createElement(InfoLine, { className: s.date, dataHook: "issue-date" }, t('invoice-view:quote.form.issue_date') + ": " + date(new Date(issueDate))));
    };
    return (React.createElement("div", { className: s.info },
        React.createElement(Heading, { className: s.number, appearance: 'H3', dataHook: "invoice-number" }, invoiceNumber),
        React.createElement(OrderReference, null),
        !!referenceText && (React.createElement(InfoLine, { dataHook: "reference-text" }, referenceText)),
        issueDateLine(),
        dueDateLine(),
        documentCustomFields &&
            documentCustomFields.length > 0 &&
            (React.createElement("div", { "data-hook": "document-custom-fields", className: s.info }, getCustomFields()))));
};
export default WithInvoiceInfoLoader(translate(['invoice-view', 'locale-data'])(InvoiceInfo));
//# sourceMappingURL=InvoiceInfo.js.map